import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmacionsimple',
  templateUrl: './confirmacionsimple.component.html',
  styleUrls: ['./confirmacionsimple.component.scss']
})
export class ConfirmacionsimpleComponent {

  titulo:string='';
  mensaje:string='';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,public dialogRef: MatDialogRef<ConfirmacionsimpleComponent>){

    this.titulo = data.titulo;
    this.mensaje = data.mensaje;

  }

  close(){
    this.dialogRef.close();
  }




}
